import React, { useState } from "react";
import { setPage, setLicencePlate } from "../../../../stores/WashingStore/WashingStore";
import { PAGES } from "../../../../stores/WashingStore/WashingStore.types";
import TotemSkeleton from "../../components/TotemSkeleton/TotemSkeleton";
import TotemButton from "../../components/TotemButton/TotemButton";
import CustomKeyboard from "../../../../components/CustomKeyboard/CustomKeyboard";
import { TextField } from "@mui/material";
import { Wrapper, KeyboardWrapper, TextWrapper } from "./ChooseLicenceStyles";

const plateRegex = /^[A-Za-z]{3}[0-9][A-Za-z0-9][0-9]{2}$/;

const ChooseLicence: React.FC = () => {
  const [licence, setLicence] = useState("");

  const handleChange = (value: string) => {
    const filtered = value.replace(/[^A-Za-z0-9]/g, "");
    const upperValue = filtered.toUpperCase();

    if (upperValue.length <= 7) {
      setLicence(upperValue);
    }
  };

  const handleNext = () => {
    if (!plateRegex.test(licence)) return;
    setLicencePlate(licence);
    setPage(PAGES.CHOOSE_WASHING);
  };

  const handleCancel = () => {
    setPage(PAGES.START_PAGE);
  };

  const Buttons = (
    <>
      <TotemButton negative onClick={handleCancel} text="Cancelar" />
      <TotemButton
        onClick={handleNext}
        text="Avançar"
        disabled={!plateRegex.test(licence)}
      />
    </>
  );

  return (
    <TotemSkeleton title="Identificação do Veículo" buttons={Buttons}>
      <Wrapper>
        <TextWrapper>
          <TextField
            fullWidth
            value={licence}
            onChange={e => handleChange(e.target.value)}
            placeholder="Placa do Veículo"
            variant="outlined"
            slotProps={{
              htmlInput: {
                maxLength: 7,
                style: { fontSize: 32, textAlign: "center", textTransform: "uppercase" },
                inputMode: "text",
                pattern: "[A-Za-z0-9]*"
              }
            }}
            style={{ marginBottom: "2rem" }}
            error={licence.length === 7 && !plateRegex.test(licence)}
            helperText={
              licence.length === 7 && !plateRegex.test(licence)
                ? "Formato inválido. Ex: ABC1234 ou ABC1D23"
                : " "
            }
          />
        </TextWrapper>
        <KeyboardWrapper>
          <CustomKeyboard setValue={setLicence} type="text"/>
        </KeyboardWrapper>
      </Wrapper>
    </TotemSkeleton>
  );
};

export default ChooseLicence;
